import { FleekError } from './FleekError';

type Site = {
  id?: string;
  name?: string;
};
type IpnsRecordsForSiteLimitErrorOptions = {
  site: Site;
};

export class IpnsRecordsForSiteLimitError extends FleekError<IpnsRecordsForSiteLimitErrorOptions> {
  public name = 'IpnsRecordsForSiteLimitError';

  toString = () => {
    if (this.data.site.name) {
      return `Maximum amount of IPNS records that may be assigned to the ${this.data.site.name} site was exceeded.`;
    }

    return `Maximum amount of IPNS records that may be assigned to the site was exceeded.`;
  };
}
